import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Params {
    message: string;
}

const IdentifyFailActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { message } = params;
    const toast = useToast();
    const { replace } = useFlow();
    const { t } = useTranslation('common');
    useEffect(() => {
        toast.error(message || t('identifyFailed2'));
        replace('MainActivity', {}, { animate: false });
    }, [message, t]);
    return (
        <AppScreen>
            <div></div>
        </AppScreen>
    );
};

export default IdentifyFailActivity;
